import { defineStore } from 'pinia'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'

export const useLobSettingStore = defineStore('LobSettingStore', {
    state: () => {
        return {
            lobSetting: {
                lob_key: null,
                live_lob_key: null,
                mode: null
            },
            route: useRoute(),
            router: useRouter(),
            homepage: 'https://www.lob.com/',
            switchmail: 'switchmail',
            quadient: 'quadient',
            quadientPreOperationalPeriod: process.env.MIX_QUADIENT_PRE_OPERATIONAL_PERIOD
        }
    },
    actions: {
        async fetchLobSetting() {
            try {
                const route = this.router.resolve(
                    {
                        name: 'lob-setting'
                    }
                );
                let url = route.href,
                $this = this;
                await axios.get(url)
                .then(function (response) {
                    if (response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    $this.lobSetting = response.data.data;
                });
            } catch (error) {
                console.log(error);
            }
        },
        updateLobSetting() {
            const route = this.router.resolve(
                {
                    name: 'lob-settings',
                }
            );
            axios.put(
                route.href,
                {
                    lob_key: this.lobSetting.lob_key,
                    live_lob_key: this.lobSetting.live_lob_key,
                    mode: this.lobSetting.mode
                }
            ).then(function(response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                return;
            }).catch(function(error) {
                toastr.error(error.response.data.response_msg, 'Error!');
            });
        }
    },
    getters: {
        getlobSetting: (state) => {
            return () => {
                return state.lobSetting;
            }
        },
        getUsername: (state) => {
            return () => {
                return state.lobSetting.mode == 0 ? state.lobSetting.lob_key : state.lobSetting.live_lob_key
            }
        },
    },
})